import { LarchSys } from '../../utils/larchSys';

//import * as $ from 'jquery';
//Object.assign(global, { $, jQuery: $ });

import './jquery.fancybox.js';
import './jquery.fancybox.scss';


export function fancyboxFeature(larchSys: LarchSys) {

    $.fancybox.defaults.animationEffect = 'fade';

    $.fancybox.defaults.afterLoad = (instance: Fancybox, current: any) => {

        if (/\.svg/.test(current.src)) {
            current.width = window.innerWidth * .8;
            current.height = window.innerHeight * .8;
        }

    }

}
